// Ressalva do campo de conta na baixa manual (SC-10915). "Registrar recebimento" e
// "Marcar como pago" dizem a mesma coisa sobre o campo, então a cópia mora aqui —
// duas cópias soltas divergem na primeira vez que alguém reescrever uma delas.
// Curta de propósito: a tooltip abre por cima do formulário, e cada linha a mais
// esconde mais um campo.
export const SETTLEMENT_ACCOUNT_HINT =
  'Diz em qual conta o dinheiro entrou. É o que alimenta o filtro e o gráfico ' +
  'por conta em Contas a Receber.'
